import {
  Col,
  message,
  PageHeader,
  Row,
  Spin,
  Select,
  Checkbox,
  Space,
  Tabs,
  Radio,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { connect } from "react-redux";
// import balanceGeneralPdf from "../../../../Pdf/balanceGeneralPdf";
import {
  SelectItem,
  Form,
  FormItem,
  cuentaMask,
  RangePickerItem,
  TableItem,
  dineroDisabledMask,
  ButtonItem,
  ErrorItem,
  round2Decimals
} from "../../../../Components/Items";
import reportesDeVentasPdf from "../../../../Pdf/reporteDeVentasPdf";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import { ResponsiveLine } from "@nivo/line";
import moment from "moment";
import "moment/locale/es";
moment.locale("es");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;
const { TabPane } = Tabs;

class ReporteVentasFiscales extends Component {
  state = {
    loading: false,
    pdf: null,
    objetoClientes: null,
    todasClientes: null,
    objetoUsuarios: null,
    todasUsuarios: null,
    objetoProyectos: null,
    todasProyectos: null,
    objetoUniadesDeNegocio: null,
    todasUniadesDeNegocio: null,
    dataReporte: null,
    todasVentas: [],
    dataGrafico: [],
    campoGrafico: "subtotal",
    subtotal: 0,
    totalImpuestos: 0,
    total: 0,
    totalRetenciones: 0,
    totalACobrar: 0,
    desglosarProductos: false
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    const campoGraficoGuardado = localStorage.getItem(`graficoCampo_ReporteVentasFiscales_${this.props.empresaId}`);
    if (campoGraficoGuardado === "subtotal" || campoGraficoGuardado === "totalPagar") {
      this.setState({ campoGrafico: campoGraficoGuardado });
    }
    await axios
      .post(
        "clientes/selectClientes",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasClientes: res.data });
          this.setState({
            objetoClientes: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.stringBuscar}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "usuarios/selectUsuariosEmpresa",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasUsuarios: res.data });
          this.setState({
            objetoUsuarios: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre +
                    " " +
                    value.apellidoPaterno +
                    " " +
                    value.apellidoMaterno}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "unidadesdenegocio/selectUnidadesDeNegocio",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasUniadesDeNegocio: res.data });
          this.setState({
            objetoUniadesDeNegocio: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                  ) +
                    " - " +
                    value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    this.consultarReporteVentasFiscales({
      periodo: [moment().subtract(1, "month"), moment()],
      clientes: 0,
      vendedores: 0,
      filtrarProyecto: 0,
      estadoFacturas: 5,
    });
  }

  async crearGrafico(valueVentas, fechaInicial, fechaFinal, campoGrafico = this.state.campoGrafico) {
    let grafico = [];
    let graficoSumatoria = [];
    let graficoCostos = [];
    let graficoCostosAcumulados = [];
    let sumatoria = 0;
    let sumatoriaCostos = 0;

    let fechaCambiante = moment(fechaInicial).locale("es");
    const fechaFinalMoment = moment(fechaFinal).locale("es");

    if (fechaFinalMoment.diff(fechaCambiante, "days") <= 31) {
      while (fechaFinalMoment.diff(fechaCambiante, "days") !== -1) {
        // eslint-disable-next-line no-loop-func
        const ventas = valueVentas.filter((todasVentas) => {
          if (isNaN(todasVentas.fechaFactura)) {
            return moment(fechaCambiante).isSame(
              moment(todasVentas.fechaFactura, "DD/MM/YYYY"),
              "date"
            );
          } else {
            return false;
          }
        });

        let totalPagar = 0;
        let costoVenta = 0

        ventas.map((valueVentaDia) => {
          totalPagar += valueVentaDia[campoGrafico] || 0;
          costoVenta += valueVentaDia.costoVenta;
          return null;
        });

        grafico.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: totalPagar,
        });

        graficoSumatoria.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: totalPagar + sumatoria,
        });

        graficoCostos.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: costoVenta,
        });

        graficoCostosAcumulados.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: costoVenta + sumatoriaCostos,
        });

        sumatoria += totalPagar;
        sumatoriaCostos += costoVenta;
        fechaCambiante = moment(fechaCambiante).add(1, "day").locale("es");
      }
    } else if (fechaFinalMoment.diff(fechaCambiante, "days") < 180) {
      while (fechaFinalMoment.diff(fechaCambiante, "weeks") !== -1) {
        // eslint-disable-next-line no-loop-func
        const ventas = valueVentas.filter((todasVentas) => {
          if (isNaN(todasVentas.fechaFactura)) {
            return moment(fechaCambiante).isSame(
              moment(todasVentas.fechaFactura, "DD/MM/YYYY"),
              "week"
            );
          } else {
            return false;
          }
        });
        let totalPagar = 0;
        let costoVenta = 0

        ventas.map((valueVentaDia) => {
          totalPagar += valueVentaDia[campoGrafico] || 0;
          costoVenta += valueVentaDia.costoVenta;
          return null;
        });

        grafico.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: totalPagar,
        });

        graficoSumatoria.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: totalPagar + sumatoria,
        });

        graficoCostos.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: costoVenta,
        });

        graficoCostosAcumulados.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: costoVenta + sumatoriaCostos,
        });

        sumatoria += totalPagar;
        sumatoriaCostos += costoVenta;
        fechaCambiante = moment(fechaCambiante).add(1, "week").locale("es");
      }
    } else if (fechaFinalMoment.diff(fechaCambiante, "months") < 36) {
      while (fechaFinalMoment.diff(fechaCambiante, "months") !== -1) {
        // eslint-disable-next-line no-loop-func
        const ventas = valueVentas.filter((todasVentas) => {
          if (isNaN(todasVentas.fechaFactura)) {
            return moment(fechaCambiante).isSame(
              moment(todasVentas.fechaFactura, "DD/MM/YYYY"),
              "month"
            );
          } else {
            return false;
          }
        });
        let totalPagar = 0;
        let costoVenta = 0

        ventas.map((valueVentaDia) => {
          totalPagar += valueVentaDia[campoGrafico] || 0;
          costoVenta += valueVentaDia.costoVenta;
          return null;
        });

        grafico.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: totalPagar,
        });

        graficoSumatoria.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: totalPagar + sumatoria,
        });

        graficoCostos.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: costoVenta,
        });

        graficoCostosAcumulados.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: costoVenta + sumatoriaCostos,
        });

        sumatoria += totalPagar;
        sumatoriaCostos += costoVenta;
        fechaCambiante = moment(fechaCambiante).add(1, "month").locale("es");
      }
    } else {
      while (fechaFinalMoment.diff(fechaCambiante, "years") !== -1) {
        // eslint-disable-next-line no-loop-func
        const ventas = valueVentas.filter((todasVentas) => {
          if (isNaN(todasVentas.fechaFactura)) {
            return moment(fechaCambiante).isSame(
              moment(todasVentas.fechaFactura, "DD/MM/YYYY"),
              "year"
            );
          } else {
            return false;
          }
        });
        let totalPagar = 0;
        let costoVenta = 0

        ventas.map((valueVentaDia) => {
          totalPagar += valueVentaDia[campoGrafico] || 0;
          costoVenta += valueVentaDia.costoVenta;
          return null;
        });

        grafico.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: totalPagar,
        });

        graficoSumatoria.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: totalPagar + sumatoria,
        });

        graficoCostos.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: costoVenta,
        });

        graficoCostosAcumulados.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: costoVenta + sumatoriaCostos,
        });

        sumatoria += totalPagar;
        sumatoriaCostos += costoVenta;
        fechaCambiante = moment(fechaCambiante).add(1, "year").locale("es");
      }
    }

    await this.setState({
      dataGrafico: [
        {
          id: "Ventas",
          color: "hsl(15, 70%, 50%)",
          data: grafico,
        },
        {
          id: "Ventas Acumuladas",
          color: "hsl(15, 70%, 50%)",
          data: graficoSumatoria,
        },
        {
          id: "Costo",
          color: "hsl(219, 100%, 45%)",
          data: graficoCostos,
        },
        {
          id: "Costo Acumulado",
          color: "hsl(219, 100%, 68%)",
          data: graficoCostosAcumulados,
        },
      ],
    });
  }

  onChangeCampoGrafico = (campoGrafico) => {
    this.setState({ campoGrafico });
    localStorage.setItem(`graficoCampo_ReporteVentasFiscales_${this.props.empresaId}`, campoGrafico);
    if (this.state.dataReporte) {
      this.crearGrafico(
        this.state.todasVentas,
        this.state.dataReporte.fechaInicial,
        this.state.dataReporte.fechaFinal,
        campoGrafico
      );
    }
  };

  consultarReporteVentasFiscales(values) {
    this.setState({ loading: true });
    axios
      .post(
        "reportesDeVentas/reporteVentasFiscales",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.crearGrafico(
            res.data.ventas,
            res.data.fechaInicial,
            res.data.fechaFinal
          );
          this.setState({
            loading: false,
            dataReporte: res.data,
            todasVentas: res.data.ventas,
            subtotal: res.data.subtotal,
            totalImpuestos: res.data.totalImpuestos,
            total: res.data.total,
            totalRetenciones: res.data.totalRetenciones,
            totalACobrar: res.data.totalACobrar,
            desglosarProductos: res.data.desglosarProductos,
          });
        } else if (res.data.success === 1) {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
        }
        this.setState({ loading: false });
      });
  }

  descargarExcel() {
    const parseFecha = (val) => {
      if (!val) return val;
      const m = moment(val, "DD/MM/YYYY", true);
      return m.isValid() ? new Date(Date.UTC(m.year(), m.month(), m.date(), 12, 0, 0)) : val;
    };
    const columnasFecha = [
      "Fecha",
      "Fecha Factura",
      "Fecha Timbrado",
      "Fecha Creacion",
      "Fecha Remision",
      "Fecha probable de pago",
      "Fecha Vencimiento",
    ];
    let datosDescargar = []
    if (this.state.desglosarProductos) {
      for (const valueVenta of this.state.todasVentas) {
        if (valueVenta.folio === '') {
          const venta = this.state.todasVentas.find(todasventas => todasventas.folio !== '' && todasventas._id.toString() === valueVenta._id.toString())
          datosDescargar.push({
            "Folio Factura": venta.folioFactura,
            "Serie Factura": venta.serieFactura,
            "Folio Remision": venta.folioRemision,
            "Serie Remision": venta.serieRemision,
            "Codigo Cliente": venta.codigoCliente,
            "Clave Cliente": venta.claveCliente,
            "Fecha Factura": parseFecha(venta.fechaFactura),
            "Fecha Timbrado": parseFecha(venta.fechaTimbrado),
            "Fecha Creacion": parseFecha(venta.fechaCreacion),
            "Fecha Remision": parseFecha(venta.fechaRemision),
            Cliente: venta.cliente,
            "Razon social": venta.razonSocial,
            "Codigo Insumo": valueVenta.codigoCliente,
            "Clave Insumo": valueVenta.claveCliente,
            "Cantidad": valueVenta.fechaFactura,
            "Descripcion": valueVenta.cliente,
            "Familia": valueVenta.familia,
            "Marca": valueVenta.marca,
            "Precio Unitario": valueVenta.total,
            "Descuento": valueVenta.descuento,
            Costo: valueVenta.costoTotal,
            "Subtotal Insumo": valueVenta.totalPagado,
            "Precio Con Impuestos": valueVenta.saldo,
            "Total Insumo": valueVenta.estado,
            "Fecha probable de pago": parseFecha(venta.fechaPago),
            "Metodo de Pago": venta.metodoPago,
            "forma de Pago": venta.formaPago,
            "Fecha Vencimiento": parseFecha(venta.fechaVencimiento),
            "Dias Vencidos": venta.diasVencidos,
            SubTotal: venta.subtotal,
            Impuestos: venta.totalImpuestos,
            "Retenciones": venta.totalRetenciones,
            Total: venta.total,
            "Total A Cobrar": venta.totalPagar,
            Moneda: venta.moneda,
            "Tipo de Cambio": venta.tipoDeCambio,
            "Folio Fiscal": venta.folioFiscal,
            Estatus: venta.estatus,
            Abonos: venta.totalPagado,
            Saldo: venta.saldo,
            Estado: venta.estado,
            Vendedor: venta.vendedor,
          })
        }
      }
    } else {
      datosDescargar = this.state.todasVentas.map((valueVenta) => {
        // const fechaHoy = moment();
        // let diasVencidos = "";

        // if (valueVenta.fechaVencimiento) {
        //   const fechaVencimiento = moment(valueVenta.fechaVencimiento);
        //   if (fechaVencimiento.isValid()) {
        //     let diff = fechaHoy.diff(fechaVencimiento, "days");
        //     diasVencidos = diff > 0 ? diff : 0; // solo positivos
        //   } else {
        //     diasVencidos = ""; // si la fecha no es válida
        //   }
        // }
        let impuesosAgregar = {}
        if (Array.isArray(valueVenta.arrayImpuestos)) {
          valueVenta.arrayImpuestos.forEach(impuesto => {
            impuesosAgregar[impuesto.descripcionFactura] = round2Decimals(impuesto.totalImpuestos)
          });
        }
        return {
          "Folio Factura": valueVenta.folioFactura,
          "Serie Factura": valueVenta.serieFactura,
          "Folio Remision": valueVenta.folioRemision,
          "Serie Remision": valueVenta.serieRemision,
          "Codigo Cliente": valueVenta.codigoCliente,
          "Clave Cliente": valueVenta.claveCliente,
          "Fecha Factura": parseFecha(valueVenta.fechaFactura),
          "Fecha Timbrado": parseFecha(valueVenta.fechaTimbrado),
          "Fecha Creacion": parseFecha(valueVenta.fechaCreacion),
          "Fecha Remision": parseFecha(valueVenta.fechaRemision),
          Cliente: valueVenta.cliente,
          "Razon social": valueVenta.razonSocial,
          "Fecha probable de pago": parseFecha(valueVenta.fechaPago),
          "Metodo de Pago": valueVenta.metodoPago,
          "Forma de Pago": valueVenta.formaPago,
          "Fecha Vencimiento": parseFecha(valueVenta.fechaVencimiento),
          "Dias Credito": valueVenta.diasCredito,
          "Orden de Compra": valueVenta.ordenDeCompra,
          //"Dias Vencidos": diasVencidos,
          SubTotal: valueVenta.subtotal,
          Impuestos: valueVenta.totalImpuestos,
          "Retenciones": valueVenta.totalRetenciones,
          Total: valueVenta.total,
          "Total A Cobrar": valueVenta.totalPagar,
          Moneda: valueVenta.moneda,
          "Tipo de Cambio": valueVenta.tipoDeCambio,
          "Folio Fiscal": valueVenta.folioFiscal,
          Estatus: valueVenta.estado,
          Costo: valueVenta.costoTotal,
          Abonos: valueVenta.totalPagado,
          Saldo: valueVenta.saldo,
          Estado: valueVenta.estado,
          Vendedor: valueVenta.vendedor,
          ...impuesosAgregar,
        };
      });
    }
    const worksheet = XLSX.utils.json_to_sheet(datosDescargar, { cellDates: true });
    if (worksheet["!ref"]) {
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      const indicesFecha = [];
      for (let C = range.s.c; C <= range.e.c; C++) {
        const header = worksheet[XLSX.utils.encode_cell({ r: range.s.r, c: C })];
        if (header && columnasFecha.includes(header.v)) {
          indicesFecha.push(C);
        }
      }
      for (let R = range.s.r + 1; R <= range.e.r; R++) {
        for (const C of indicesFecha) {
          const cell = worksheet[XLSX.utils.encode_cell({ r: R, c: C })];
          if (cell && cell.v instanceof Date) {
            cell.t = "d";
            cell.z = "dd/mm/yyyy";
          }
        }
      }
    }
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte Ventas");
    //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workbook, `Reporte_De_Ventas_${moment().locale("es").format("L")}.xlsx`);
  }

  descargarPdf() {
    pdfMake
      .createPdf(reportesDeVentasPdf(this.state.dataReporte))
      .download(`Reporte_De_Ventas_${moment().locale("es").format("L")}`);
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }
  render() {
    const columns = [
      {
        title: "Folio",
        dataIndex: "folio",
        key: "folio",
        sorter: (a, b) => {
          if (a.folio < b.folio) {
            return -1;
          }
          if (a.folio > b.folio) {
            return 1;
          }
          return 0;
        },
        buscar: "folio",
        ellipsis: true,
      },
      {
        title: "Fecha Remision",
        dataIndex: "fechaRemision",
        key: "fechaRemision",
        sorter: (a, b) => {
          if (moment(a.fechaRemision, "DD/MM/YYYY") < moment(b.fechaRemision, "DD/MM/YYYY")) {
            return -1;
          }
          if (moment(a.fechaRemision, "DD/MM/YYYY") > moment(b.fechaRemision, "DD/MM/YYYY")) {
            return 1;
          }
          return 0;
        },
        buscar: "fechaRemision",
        ellipsis: true,
      },
      {
        title: "Fecha Factura",
        dataIndex: "fechaFactura",
        key: "fechaFactura",
        sorter: (a, b) => {
          if (moment(a.fechaFactura, "DD/MM/YYYY") < moment(b.fechaFactura, "DD/MM/YYYY")) {
            return -1;
          }
          if (moment(a.fechaFactura, "DD/MM/YYYY") > moment(b.fechaFactura, "DD/MM/YYYY")) {
            return 1;
          }
          return 0;
        },
        buscar: "fechaFactura",
        ellipsis: true,
      },
      {
        title: "Cliente",
        dataIndex: "cliente",
        key: "cliente",
        sorter: (a, b) => {
          if (a.cliente < b.cliente) {
            return -1;
          }
          if (a.cliente > b.cliente) {
            return 1;
          }
          return 0;
        },
        buscar: "cliente",
        ellipsis: true,
      },
      {
        title: "Vencimiento",
        dataIndex: "fechaVencimiento",
        key: "fechaVencimiento",
        sorter: (a, b) => {
          if (!a.fechaVencimiento && !b.fechaVencimiento) return 0;
          if (!a.fechaVencimiento) return 1;
          if (!b.fechaVencimiento) return -1;
          if (moment(a.fechaVencimiento, "DD/MM/YYYY") < moment(b.fechaVencimiento, "DD/MM/YYYY")) {
            return -1;
          }
          if (moment(a.fechaVencimiento, "DD/MM/YYYY") > moment(b.fechaVencimiento, "DD/MM/YYYY")) {
            return 1;
          }
          return 0;
        },
        buscar: "fechaVencimiento",
        ellipsis: true,
      },
      {
        title: "Total",
        dataIndex: "totalPagar",
        key: "totalPagar",
        sorter: (a, b) => {
          if (a.totalPagar < b.totalPagar) {
            return -1;
          }
          if (a.totalPagar > b.totalPagar) {
            return 1;
          }
          return 0;
        },
        buscar: "totalPagar",
        render: (value) => dineroDisabledMask(value),
        align: "right",
        ellipsis: true,
      },  
      {
        title: "Costo",
        dataIndex: "costoTotal",
        key: "costoTotal",
        sorter: (a, b) => {
          if (a.costoTotal < b.costoTotal) {
            return -1;
          }
          if (a.costoTotal > b.costoTotal) {
            return 1;
          }
          return 0;
        },
        buscar: "costoTotal",
        render: (value) => dineroDisabledMask(value),
        align: "right",
        ellipsis: true,
      },
      {
        title: "Abonos",
        dataIndex: "totalPagado",
        key: "totalPagado",
        sorter: (a, b) => {
          if (a.totalPagado < b.totalPagado) {
            return -1;
          }
          if (a.totalPagado > b.totalPagado) {
            return 1;
          }
          return 0;
        },
        buscar: "totalPagado",
        ellipsis: true,
        render: (value) => dineroDisabledMask(value),
        align: "right",
      },
      {
        title: "Saldo",
        dataIndex: "saldo",
        key: "saldo",
        sorter: (a, b) => {
          if (a.saldo < b.saldo) {
            return -1;
          }
          if (a.saldo > b.saldo) {
            return 1;
          }
          return 0;
        },
        buscar: "saldo",
        ellipsis: true,
        render: (value) => dineroDisabledMask(value),
        align: "right",
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        sorter: (a, b) => {
          if (a.estado < b.estado) {
            return -1;
          }
          if (a.estado > b.estado) {
            return 1;
          }
          return 0;
        },
        buscar: "estado",
        ellipsis: true,
      },
      {
        title: "Vendedor",
        dataIndex: "vendedor",
        key: "vendedor",
        sorter: (a, b) => {
          if (a.vendedor < b.vendedor) {
            return -1;
          }
          if (a.vendedor > b.vendedor) {
            return 1;
          }
          return 0;
        },
        buscar: "vendedor",
        ellipsis: true,
      },
    ];
    return (
      <>
        <Form
          ref={this.formRef}
          name="reporteVentasFiscales"
          onFinish={this.consultarReporteVentasFiscales.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={{
            periodo: [moment().subtract(1, "month"), moment()],
          }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte Ventas Fiscales"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarExcel()}
                      icon={<FileExcelOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar Excel
                    </ButtonItem>
                  )}
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarPdf()}
                      icon={<FilePdfOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar PDF
                    </ButtonItem>
                  )}
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Tabs
                style={{ margin: 0 }}
                tabBarExtraContent={{
                  left: (
                    <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>
                      Filtros:
                    </h1>
                  ),
                }}
              >
                <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                  <FormItem name="periodo" required noStyle>
                    <RangePickerItem />
                  </FormItem>
                </TabPane>
                <TabPane tabKey="2" key="2" forceRender tab="Clientes">
                  <FormItem name="clientes" noStyle margin>
                    <SelectItem
                      width="90%"
                      mode="multiple"
                      placeholder="Clientes"
                    >
                      {this.state.objetoClientes}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="3" key="3" forceRender tab="Vendedores">
                  <FormItem name="vendedores" margin noStyle>
                    <SelectItem
                      width="90%"
                      mode="multiple"
                      placeholder="Vendedores"
                    >
                      {this.state.objetoUsuarios}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="4" key="4" forceRender tab="Proyecto">
                  <Row>
                    <Col span={8}>
                      <FormItem
                        name="filtrarProyecto"
                        required
                        noStyle
                        initialValue={0}
                      >
                        <SelectItem width="90%" placeholder="Filtrar Proyecto">
                          <Option default value={0}>
                            Niguno
                          </Option>
                          <Option value={1}>Proyectos</Option>
                          <Option value={2}>Unidades de negocio</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const filtrarProyecto =
                            getFieldValue("filtrarProyecto");
                          if (filtrarProyecto === 1) {
                            return (
                              <FormItem required name="proyectos" margin noStyle>
                                <SelectItem
                                  width="90%"
                                  placeholder="Proyectos"
                                  mode="multiple"
                                >
                                  {this.state.objetoProyectos}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                          if (filtrarProyecto === 2) {
                            return (
                              <FormItem required margin name="unidadDeNegocioId" noStyle>
                                <SelectItem
                                  width="90%"
                                  placeholder="Unidades de Negocio"
                                >
                                  {this.state.objetoUniadesDeNegocio}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                        }}
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabKey="5" key="5" forceRender tab="Detalles">
                  <Row style={{ padding: 0, margin: 0 }} gutter={[16, 0]}>
                    <Col span={8}>
                      <FormItem
                        label="Estado"
                        name="estadoFacturas"
                        required
                        initialValue={5}
                        style={{ marginBottom: 0 }}
                      >
                        <SelectItem placeholder="Filtrar Por">
                          <Option default value={5}>
                            Activas
                          </Option>
                          <Option value={4}>Por Cobrar</Option>
                          <Option value={3}>Cobrada</Option>
                          <Option value={2}>Vencida</Option>
                          <Option value={1}>Canceladas</Option>
                          <Option value={0}>Todas (Activas y Canceladas)</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem
                        label="Desglosar Productos"
                        name="desglosarProductos"
                        valuePropName="checked"
                        margin
                      >
                        <Checkbox />
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      {/* <FormItem
                        label="Detalle"
                        name="detalle"
                        valuePropName="checked"
                        margin
                      >
                        <Checkbox />
                      </FormItem> */}
                    </Col>
                  </Row>
                </TabPane>
              </Tabs>
            </div>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingBottom: 35,
                marginTop: 10,
                marginBottom: 10,
                height: 420,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 10 }}>
                <h1 style={{ fontSize: 18, margin: 0 }}>Gráfico</h1>
                <Radio.Group
                  size="small"
                  value={this.state.campoGrafico}
                  onChange={(e) => this.onChangeCampoGrafico(e.target.value)}
                >
                  <Radio.Button value="subtotal">Subtotal</Radio.Button>
                  <Radio.Button value="totalPagar">Total a Pagar</Radio.Button>
                </Radio.Group>
              </div>

              <ResponsiveLine
                data={this.state.dataGrafico}
                margin={{ top: 15, right: 20, bottom: 70, left: 100 }}

                // ✅ Tooltips tipo “línea vertical” (mucho más claro)
                enableSlices="x"
                useMesh={true}

                yFormat={(e) => dineroDisabledMask(Math.abs(e))}

                xScale={{ type: "point" }}
                yScale={{
                  type: "linear",
                  min: 0,
                  max: "auto",
                  stacked: false,
                  reverse: false,
                }}

                curve="monotoneX"
                lineWidth={2}

                // ✅ Menos ruido visual
                pointSize={5}
                pointBorderWidth={1}
                pointColor={{ theme: "background" }}
                pointBorderColor={{ from: "serieColor" }}

                // Si quieres aún más limpio, descomenta:
                // enablePoints={false}

                colors={["#14B8A6", "#F97316", "#8B5CF6", "#EF4444"]}
                colorBy="index"

                axisTop={null}
                axisRight={null}

                axisBottom={{
                  tickSize: 5,
                  tickPadding: 8,
                  tickRotation: 45,
                  // ✅ muestra menos etiquetas (una de cada 2 o 3)
                  tickValues: (this.state.dataGrafico?.[0]?.data || [])
                    .map(d => d.x)
                    .filter((_, i) => i % 2 === 0),
                }}

                axisLeft={{
                  tickSize: 5,
                  tickPadding: 8,
                  format: (v) => dineroDisabledMask(Math.abs(v)),
                }}

                // ✅ Grid más limpio
                enableGridX={false}

                legends={[
                  {
                    anchor: "top-right",
                    direction: "column",
                    translateX: 0,
                    translateY: 0,
                    itemWidth: 130,
                    itemHeight: 18,
                    symbolSize: 10,
                    symbolShape: "circle",
                    itemOpacity: 0.85,
                    effects: [
                      {
                        on: "hover",
                        style: {
                          itemOpacity: 1,
                        },
                      },
                    ],
                  },
                ]}
              />
            </div>
            <div
              style={{
                backgroundColor: "white",
                padding: 15,
                marginBottom: 10,
                height: "75px",
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Row>
                <Col span={4} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Subtotal</p>
                  <h1 style={{ fontSize: 15 }}>
                    {dineroDisabledMask(this.state.subtotal)}
                  </h1>
                </Col>
                <Col span={1} style={{ textAlign: "center" }}>
                  <h1 style={{ fontSize: 20 }}>+</h1>
                </Col>
                <Col span={4} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Impuestos</p>
                  <h1 style={{ fontSize: 15 }}>
                    {dineroDisabledMask(this.state.totalImpuestos)}
                  </h1>
                </Col>
                <Col span={1} style={{ textAlign: "center" }}>
                  <h1 style={{ fontSize: 20 }}>=</h1>
                </Col>
                <Col span={4} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Total</p>
                  <h1 style={{ fontSize: 15 }}>
                    {dineroDisabledMask(this.state.total)}
                  </h1>
                </Col>
                <Col span={1} style={{ textAlign: "center" }}>
                  <h1 style={{ fontSize: 20 }}>-</h1>
                </Col>
                <Col span={4} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Retenciones</p>
                  <h1 style={{ fontSize: 15 }}>
                    {dineroDisabledMask(this.state.totalRetenciones)}
                  </h1>
                </Col>
                <Col span={1} style={{ textAlign: "center" }}>
                  <h1 style={{ fontSize: 20 }}>=</h1>
                </Col>
                <Col span={4} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Total Cobrar</p>
                  <h1 style={{ fontSize: 15 }}>
                    {dineroDisabledMask(this.state.totalACobrar)}
                  </h1>
                </Col>
              </Row>
            </div>
            <TableItem
              onRow={(record, rowIndex) => {
                return {
                  onDoubleClick: (event) => {
                    this.props.history.push("/panel/verVenta", {
                      id: record._id,
                    });
                  },
                };
              }}
              rowKey={(value) => value._id.toString() + Math.random()}
              columns={columns}
              dataSource={this.state.todasVentas}
              size="small"
              pagination={false}
            />
            {/* <div style={{ backgroundColor: "white", padding: 20, paddingTop: 5 }}>
          {this.state.pdf && (
            <iframe
              title={"documentos"}
              style={{ width: "100%", height: "100vh" }}
              id="printPdf"
              name="printPdf"
            />
          )}
        </div> */}
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ReporteVentasFiscales);
